import { render, staticRenderFns } from "./UserBoxPortrait.vue?vue&type=template&id=d6e25e6c"
import script from "./UserBoxPortrait.vue?vue&type=script&lang=js"
export * from "./UserBoxPortrait.vue?vue&type=script&lang=js"
import style0 from "./UserBoxPortrait.vue?vue&type=style&index=0&id=d6e25e6c&prod&lang=scss"
import style1 from "./UserBoxPortrait.vue?vue&type=style&index=1&id=d6e25e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports